import { Input, SearchableSelect, searchableSource, type FormConfig } from '@eo/shared';

import type { ExcessAdditionFormContext, ExcessAdditionValues } from '../types';

// The entry is logged in ClickUp as variable time by whoever generates the bill,
// on one of the client's open tasks.
export const excessAdditionFormConfig: FormConfig<ExcessAdditionValues, ExcessAdditionFormContext> =
  {
    fields: [
      {
        id: 'taskId',
        label: 'Task',
        required: true,
        render: (form, { clientId, clientTasks, onQueryOptions }) => (
          <SearchableSelect
            value={form.values.taskId}
            ariaLabel="Task"
            placeholder="Pick one of the client’s tasks"
            emptyLabel="No open task matches"
            options={clientTasks.items.map((task) => ({ value: task.id, label: task.name }))}
            selectedLabel={form.values.taskName || undefined}
            {...searchableSource(clientTasks, (params) =>
              onQueryOptions({ source: 'clientTasks', ...params, filters: { clientId } }),
            )}
            onChange={(value) => {
              form.set('taskId', value);
              form.set('taskName', clientTasks.items.find((t) => t.id === value)?.name ?? '');
            }}
          />
        ),
      },
      {
        id: 'date',
        label: 'Date',
        required: true,
        colSpan: 1,
        render: (form) => (
          <Input
            id="field-date"
            type="date"
            value={form.values.date}
            onChange={(event) => form.set('date', event.target.value)}
          />
        ),
      },
      { id: 'hours', label: 'Hours', type: 'number', required: true, colSpan: 1 },
      { id: 'note', label: 'Note', type: 'textarea', rows: 2, placeholder: 'Optional' },
    ],
  };
